<template>

    <v-modal title="Invite Member" :loading="starting">

        <template #body>
            <v-alert :message="error" />
            <p class="small mb-20">Enter an email address to invite a member to your company.<br>Separate multiple email addresses with a comma.</p>
            <v-form-group dir="ver" label="Email">
                <v-input class="mb-15" placeholder="person@mycompany.com" :model="params.email" @input="params.email = $event" />
            </v-form-group>
            <v-form-group dir="ver" label="Role">
                <v-list grouped>
                    <v-list-item size="sm" v-for="r in selectableRoles" :key="r.id">
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="pr-30">
                                <span>{{ r.name }}<br><span class="small text-muted">{{ r.description }}</span></span>
                            </div>
                            <v-button
                                size="xs"
                                :btn-style="params.role_id === r.id ? 'success' : 'secondary'"
                                :btn-label="params.role_id === r.id ? 'Selected' : 'Select'"
                                @click.native="selectRole(r.id)">
                            </v-button>
                        </div>
                     </v-list-item>
                </v-list>
            </v-form-group>
            <v-form-group v-if="params.role_id !== ownerRole.id" dir="ver">
                <v-checkbox label="Assign to all projects" :model="assignAllProjects" @input="selectAllProjects($event)" />
            </v-form-group>
            <v-form-group v-if="!assignAllProjects" dir="ver">
                <v-list grouped>
                    <v-list-item size="sm" v-for="p in projects" :key="p.id">
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="pr-30">
                                <span>{{ p.name }}<br><span class="small text-muted">{{ p.website }}</span></span>
                            </div>
                            <v-button
                                size="xs"
                                :btn-style="params.project_ids.includes(p.id) ? 'success' : 'secondary'"
                                :btn-label="params.project_ids.includes(p.id) ? 'Selected' : 'Select'"
                                @click.native="selectProject(p.id)">
                            </v-button>
                        </div>
                     </v-list-item>
                </v-list>
            </v-form-group>
        </template>

        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <v-button size="sm" :loading="loading" @click.native="createMemberInvite">Invite Member</v-button>
        </template>

    </v-modal>

</template>

<script>

import axios from 'axios';
import CompanyApi from '@api/CompanyApi'
import RoleApi from '@api/RoleApi';

export default {

    data() {
        return {
            starting: true,
            loading: false,
            error: null,
            roles: [],
            projects: [],
            assignAllProjects: true,
            params: {
                role_id: '',
                project_ids: [],
            },
        }
    },

    computed: {

        ownerRole() {
            return this.roles.find(r => r.slug === 'owner');
        },

        selectableRoles() {
            return this.roles.filter(r => r.slug !== 'owner');
        },

    },

    mounted() {
        this.reload();
    },

    methods: {

        reload() {
            let requests = [
                RoleApi.getRoles(),
                CompanyApi.getProjects(this.$store.getters.company.id),
            ];
            axios.all(requests)
                .then(axios.spread((resRoles, resProjects) => {
                    this.$store.commit('loading', false);
                    this.roles = resRoles.data.data;
                    this.projects = resProjects.data.data;
                    // Set params.
                    this.params.role_id = resRoles.data.data.find(r => r.slug === 'manager').id;
                    this.params.project_ids = resProjects.data.data.map(p => p.id);
                    this.starting = false;
                }), (error) => {
                    this.starting = false;
                    this.error = error.response.data.message;
                });
        },

        createMemberInvite() {
            this.loading = true;
            CompanyApi.createMemberInvite(this.$store.getters.company.id, this.params)
                .then((response) => {
                    this.loading = false;
                    this.$emit('created');
                    this.$store.commit('setAlertSuccess', this.$t('message.sent'));
                    this.$store.commit('showModal', false);
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                });
        },

        selectRole(id) {
            this.params.role_id = id;
            if (id === this.ownerRole.id) {
                this.selectAllProjects(true);
            }
        },

        selectProject(id) {
            let index = this.params.project_ids.findIndex(p => p === id);
            if (index >= 0) {
                this.params.project_ids.splice(index, 1);
            } else {
                this.params.project_ids.push(id);
            }
        },

        selectAllProjects(val) {
            this.params.project_ids = val ? this.projects.map(p => p.id) : [];
            this.assignAllProjects = val;
        },

        cancel() {
            this.$store.commit('showModal', false);
        },

    },

}

</script>
